import {
    GET_ARTICLES,
    GET_ARTICLES_SUCCESS,
    GET_ARTICLES_FAILURE,
    GET_RELATED_ARTICLES,
    GET_RELATED_ARTICLES_SUCCESS,
    GET_RELATED_ARTICLES_FAILURE,
    GET_FACET_DETAIL,
    GET_FACET_DETAIL_SUCCESS,
    GET_FACET_DETAIL_FAILURE,
    GET_TITLE,
    GET_TITLE_SUCCESS,
    GET_TITLE_FAILURE
} from "../constants";
import axios from 'axios';
import history from 'middlewares/history';
import { SEARCH_BASE_URL, AUTH_BASE_URL } from '../config';
import { isNativeAmerican } from '../components/Article/common/utilities';
import { receiveLogin, receiveLoginFail } from './user';

// main news search handlers
export const requestArticles = () => ({ type: GET_ARTICLES });
export const receiveArticles = records => ({
    type: GET_ARTICLES_SUCCESS,
    records
});
export const receiveArticlesFail = error => ({
    type: GET_ARTICLES_FAILURE,
    error
});

// similar news article handlers
export const requestSimilarArticles = () => ({ type: GET_RELATED_ARTICLES });
export const receiveSimilarArticles = records => ({
    type: GET_RELATED_ARTICLES_SUCCESS,
    records
});
export const receiveSimilarArticlesFail = error => ({
    type: GET_RELATED_ARTICLES_FAILURE,
    error
});

// I don't know what the ones below are, investigate and delete if possible
export const requestFacetDetail = facet => ({
    type: GET_FACET_DETAIL,
    facet,
    meta: {
        throttle: true
    }
});
export const receiveFacetDetail = (records, facet) => ({
    type: GET_FACET_DETAIL_SUCCESS,
    records,
    facet
});
export const receiveFacetDetailFail = (error, facet) => ({
    type: GET_FACET_DETAIL_FAILURE,
    error,
    facet
});

export const requestTitle = url => ({
    type: GET_TITLE,
    url
});
export const receiveTitle = (result, url) => ({
    type: GET_TITLE_SUCCESS,
    result,
    url
});
export const receiveTitleFail = (error, url) => ({
    type: GET_TITLE_FAILURE,
    error,
    url
});

const URL_FIELDS = [
  // "link",
  // "base_url",
  "icon_url",
  "image"
];

export const fetchNews = (
    searchTerm,
    searchDate,
    selectedFacets,
    options
) => dispatch => {
    let term = searchTerm,
        facetTerm = {},
        routerQueryParams = '?';
    const encode = encodeURI;

    // todo: make sure that commenting this out doesn't break anything
    // term = term.replace(/"/g, '\\"');

    if(searchTerm)
        routerQueryParams += `query=${encode(searchTerm)}&`;

    if(searchDate)
        routerQueryParams += `date=${encode(searchDate)}&`;

    if (selectedFacets) {
        Object.keys(selectedFacets).map(key=>{
            if(selectedFacets[key].length) {
                if (key === "subjects") {
                    facetTerm.subject_codes = selectedFacets[key];
                }
                else if (key === "pop_groups") {
                    facetTerm.pop_group_codes = selectedFacets[key];
                }
                else {
                    facetTerm[key] = selectedFacets[key];
                }
                // routerQueryParams += `${key}=${encode(selectedFacets[key].join(','))}&`;
                routerQueryParams += `${key}=${selectedFacets[key].map(encodeURIComponent).join(',')}&`;
            }
            return key
        })
    }

    if (options) {
        Object.keys(options).map(key => {
            routerQueryParams += `${key}=${encode(options[key])}&`;
        })
    }

    //remove the last '&'
    routerQueryParams = routerQueryParams.slice(0, -1)
    history.push(`/${routerQueryParams}`);
    dispatch(requestArticles());

    let payload = {
        route: "search_es",
        size: 100,
        q: term,
        searchdate: searchDate,
        facet: facetTerm,
        options: options,
        summary: false,
        experimental: true,
        skip_aggregations: false,
        sort_experiment: options.salience_sort,
        sort_reverse: options.sort_reverse
    };


    return axios.post(SEARCH_BASE_URL, payload, {withCredentials: true})
        .then(response => {
            // TODO: put the MySQL calls for native american philanthropy here, update the response data

            // if (response.response && response.response.status && response.response.status === 504) {
            //   return dispatch(receiveArticles({}));
            // }
            const data = response.data;
            let recordIds = [];
            let records = response.data.records.map((r, index) => {
                recordIds.push(r.data_id);

                // strip out http: and https: and let the browswer decide
                // this is to make the page more secure, as recommended by https://webmasters.stackexchange.com/questions/87987/https-connection-is-not-safe-due-to-images
                URL_FIELDS.map((field_name, i) => {
                  if ( r[field_name] !== null ) {
                    if (r[field_name].match(/http:\/\//i)) {
                      r[field_name] = null;
                    }
                    else {
                      r[field_name] = r[field_name].replace(/http(s)?:\/\//i, '//');
                    }
                  }
                });
                return {...r, isNAP: isNativeAmerican(r.populations)}
            });
            let recordsLookup = {};
            records.map((record, index) => recordsLookup[record.data_id] = index);

            const payload = {route: "get_status", data_ids: recordIds};
            return axios.post(SEARCH_BASE_URL, payload, {withCredentials: true})
                .then(response => {
                    const frontFeedback = response.data.feedback;
                    const complete = response.data.complete;

                    // merge the user feedback data into the response JSON objects
                    for (let [key, value] of Object.entries(frontFeedback)) {
                        if (!("feedback" in records[recordsLookup[key]])) {
                            records[recordsLookup[key]].feedback = {};
                        }
                        for (let [topic, status] of Object.entries(value)) {
                            records[recordsLookup[key]].feedback[topic] = status;
                        }
                    }

                    // update the "complete" status
                    complete.map((key, index) => {records[recordsLookup[key]].complete = true;})

                    return dispatch(receiveArticles({
                        ...data, 
                        records: records
                    }));
                })
                .catch(error => {
                    dispatch(receiveArticles({
                        ...data,
                        records: records
                    }))
                })
        })
        .catch(error => {
            axios.post(`${AUTH_BASE_URL}/fasttrack`, {}, {withCredentials: true})
                .then(response => {
                    const search = routerQueryParams;
                    const authenticated = response && !(response.message && response.message.indexOf && response.message.indexOf('error'));
                    
                    if (authenticated) {
                        if (search !== '')
                            history.push(`/${search}`);
                        else
                            history.push(`/`);
                        return dispatch(receiveLogin(response.data));
                    }
                    else
                        dispatch(receiveLoginFail(response))
                })
                .catch(error => dispatch(receiveArticlesFail(error)))
        });
};

export const fetchFacetDetail = (
    searchTerm,
    searchDate,
    facet,
    input,
    selectedFacets
) => dispatch => {
    let term = searchTerm;
    // let facetTerm = "";
    let facetTerm = {};

    term = term.replace(/"/g, '\\"');

    if (selectedFacets) {
        // facetTerm = selectedFacets;

        Object.keys(selectedFacets).map(key=>{
            if(selectedFacets[key].length) {
                if (key === "subjects") {
                    // facetTerm.subject_codes_or = selectedFacets[key];
                    facetTerm.subject_codes = selectedFacets[key];
                }
                else if (key === "pop_groups") {
                    // facetTerm.pop_group_codes_or = selectedFacets[key];
                    facetTerm.pop_group_codes = selectedFacets[key];
                }
                else {
                    facetTerm[key] = selectedFacets[key];
                }
            }
            return key
        })
    }

    dispatch(requestFacetDetail(facet));

    let payload = {
        route: "autocomplete",
        text: input,
        filterFacet: facet,
        q: term,
        searchdate: searchDate,
        facet: facetTerm,
        summary: false,
        experimental: true,
        skip_aggregations: true
    };

    return axios.post(SEARCH_BASE_URL, payload, {withCredentials: true})
        .then(response => {
            return dispatch(receiveFacetDetail(response.data, facet));
        })
        .catch(error => dispatch(receiveFacetDetailFail(error, facet)));
};

export const fetchRelatedNews = (articleId) => dispatch => {
    dispatch(requestSimilarArticles());

    let payload = { route: "fetch_related", id: articleId };
    return axios.post(SEARCH_BASE_URL, payload, {withCredentials: true})
        .then(response => {

            // TODO: put the MySQL calls for native american philanthropy here, update the response data
            const data = response.data;
            let recordIds = [];
            let records = response.data.records.map((r, index) => {
                recordIds.push(r.data_id);

                // strip out http: and https: and let the browswer decide
                // this is to make the page more secure, as recommended by https://webmasters.stackexchange.com/questions/87987/https-connection-is-not-safe-due-to-images
                URL_FIELDS.map((field_name, i) => {
                  if (r[field_name].match(/http:\/\//i)) {
                    r[field_name] = null;
                  }
                  else {
                    r[field_name] = r[field_name].replace(/http(s)?:\/\//i, '//');
                  }
                });
                return {...r, isNAP: isNativeAmerican(r.populations)}
            });
            let recordsLookup = {};
            records.map((record, index) => recordsLookup[record.data_id] = index);

            // get the user feedback statuses and update the JSON response
            const payload = {route: "get_status", data_ids: recordIds};
            return axios.post(SEARCH_BASE_URL, payload, {withCredentials: true})
                .then(response => {
                    const frontFeedback = response.data.feedback;
                    const complete = response.data.complete;

                    // merge the user feedback data into the response JSON objects
                    for (let [key, value] of Object.entries(frontFeedback)) {
                        if (!("feedback" in records[recordsLookup[key]])) {
                            records[recordsLookup[key]].feedback = {};
                        }
                        for (let [topic, status] of Object.entries(value)) {
                            records[recordsLookup[key]].feedback[topic] = status;
                        }
                    }

                    // update the "complete" status
                    complete.map((key, index) => {records[recordsLookup[key]].complete = true;});
                    history.push(`/related/${articleId}`);

                    return dispatch(receiveSimilarArticles({
                        ...data, 
                        records: records
                    }));
                })
                .catch(error => {
                    dispatch(receiveSimilarArticles({
                        ...data,
                        records: records
                    }))
                })
        })
        .catch(error => {
            axios.post(`${AUTH_BASE_URL}/fasttrack`, {}, {withCredentials: true})
                .then(response => {
                    const authenticated = response && !(response.message && response.message.indexOf && response.message.indexOf('error'));
                    
                    if (authenticated) {
                        history.push(`/related/${articleId}`);
                        return dispatch(receiveLogin(response.data));
                    }
                    else
                        dispatch(receiveLoginFail(response))
                })
                .catch(error => dispatch(receiveSimilarArticlesFail(error)))
        })
};


// WEBPACK FOOTER //
// ./src/actions/index.js